import { Component, Input, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { UserService } from '../../../layout/service/user.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { EditorModule } from 'primeng/editor';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { InputIcon } from 'primeng/inputicon';
import { IconField } from 'primeng/iconfield';
import { SelectModule } from 'primeng/select';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-packages',
    imports: [
        InputTextModule,
        DatePickerModule,
        InputNumberModule,
        FormsModule,
        CommonModule,
        MultiSelectModule,
        EditorModule,
        InputGroupAddonModule,
        InputGroupModule,
        ButtonModule,
        ToastModule,
        TableModule,
        TagModule,
        DialogModule,
        InputIcon,
        IconField,
        SelectModule,
        ConfirmDialogModule
    ],
    providers: [MessageService, ConfirmationService],
    styles: [
    `
    :host ::ng-deep {
        .p-paginator {
            .p-paginator-current {
                margin-left: auto;
            }
        }

        .p-progressbar {
            height: .5rem;
            background-color: #D8DADC;

            .p-progressbar-value {
                background-color: #607D8B;
            }
        }

        .table-header {
            display: flex;
            justify-content: space-between;
        }

        .p-calendar .p-datepicker {
            min-width: 25rem;

            td {
                font-weight: 400;
            }
        }

        .p-datatable.p-datatable-customers {
            .p-datatable-header {
                padding: 1rem;
                text-align: left;
                font-size: 1.5rem;
            }

            .p-paginator {
                padding: 1rem;
            }

            .p-datatable-thead > tr > th {
                text-align: left;
            }

            .p-datatable-tbody > tr > td {
                cursor: auto;
            }

            .p-dropdown-label:not(.p-placeholder) {
                text-transform: uppercase;
            }
        }

        .p-w-100 {
            width: 100%;
        }

        /* Responsive */
        .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
            display: none;
        }
    }

    @media screen and (max-width: 960px) {
        :host ::ng-deep {
            .p-datatable {
                &.p-datatable-customers {
                    .p-datatable-thead > tr > th,
                    .p-datatable-tfoot > tr > td {
                        display: none !important;
                    }

                    .p-datatable-tbody > tr {
                        border-bottom: 1px solid var(--layer-2);

                        > td {
                            text-align: left;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            border: 0 none;

                            .p-column-title {
                                min-width: 30%;
                                display: inline-block;
                                font-weight: bold;
                            }

                            p-progressbar {
                                width: 100%;
                            }

                            &:last-child {
                                border-bottom: 1px solid var(--surface-d);
                            }
                        }
                    }
                }
            }
        }
    }
    `
    ],
    template: `
        <p-toast />
        <p-confirmdialog />
        <p-dialog header="Form Paket Simulasi" [(visible)]="visible" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false" (onHide)="onDialogHide()">
            <form>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="flex flex-col gap-2 mb-4 col-12">
                        <label for="code">Kode</label>
                        <p-inputgroup>
                            <input pInputText id="code" aria-describedby="code-help" [(ngModel)]="code" name="code" [disabled]="true" />
                            <p-inputgroup-addon>
                                <p-button icon="pi pi-refresh" severity="secondary" variant="text" (click)="generateCode()" />
                            </p-inputgroup-addon>
                        </p-inputgroup>
                        <small id="code-help">Kode paket dibuat otomatis. Klik refresh untuk membuat kode baru.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-12">
                        <label for="code">Kode Saat Ini</label>
                        <div class="mb-0 text-3xl font-bold">{{ code }}</div>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-12 md:col-span-2">
                        <label for="description">Deskripsi</label>
                        <p-editor id="description" [(ngModel)]="description" name="description" [style]="{ height: '320px' }" />
                        <small id="description-help">Masukkan deskripsi paket simulasi.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-6">
                        <label for="name">Judul</label>
                        <input pInputText id="name" aria-describedby="name-help" [(ngModel)]="name" name="name" />
                        <small id="name-help">Masukkan judul paket simulasi.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-6">
                        <label for="cases">Kasus</label>
                        <p-multiselect id="cases" appendTo="body" [options]="forms" display="chip" [(ngModel)]="selectedOsce" name="selectedOsce" optionLabel="TITLE" placeholder="Pilih Kasus" [filter]="true" styleClass="w-full" />
                        <small id="cases-help">Pilih kasus yang akan dimasukkan ke dalam paket.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-6">
                        <label for="startDate">Tanggal Mulai</label>
                        <p-datepicker id="startDate" [(ngModel)]="startDate" name="startDate" [showTime]="true" [hourFormat]="'24'" inputId="calendar-24h" [iconDisplay]="'input'" styleClass="w-full" [showIcon]="true" />
                        <small id="startDate-help">Pilih tanggal mulai simulasi.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-6">
                        <label for="duration">Durasi (Menit)</label>
                        <p-inputnumber id="duration" [(ngModel)]="duration" name="duration" mode="decimal" inputId="withoutgrouping" [useGrouping]="false" />
                        <small id="duration-help">Masukkan durasi simulasi dalam menit.</small>
                    </div>
                    <div class="flex flex-col gap-2 mb-4 col-6">
                        <label for="maxParticipant">Peserta Maksimal</label>
                        <p-inputnumber id="maxParticipant" [(ngModel)]="maxParticipant" name="maxParticipant" mode="decimal" inputId="withoutgrouping" [useGrouping]="false" />
                        <small id="maxParticipant-help">Masukkan jumlah maksimal peserta. Gunakan <strong>0</strong> untuk tanpa batas.</small>
                    </div>
                </div>
                <div class="flex justify-end mt-6">
                    <p-button severity="success" (click)="onSave()" icon="pi pi-save" [raised]="true" variant="text" label="Simpan Paket" />
                </div>
            </form>
        </p-dialog>

        <p-dialog header="Tambah Lembar" [(visible)]="showSheetDialog" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '40vw' }" position="center" [draggable]="false" [resizable]="false">
            <div *ngIf="sheetLoading" class="flex justify-center items-center py-8">
                <p>Loading...</p>
            </div>
            <div *ngIf="!sheetLoading">
                <!-- Info Jumlah Kasus -->
                <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <div class="text-sm text-blue-800">
                        <i class="pi pi-info-circle mr-2"></i>
                        <strong>Jumlah Kasus:</strong> {{ selectedPackage ? parseOsceId(selectedPackage.osce_id).length : 0 }}
                    </div>
                    <div class="text-sm text-blue-800 mt-1">
                        <strong>Lembar Terpilih:</strong> {{ selectedSheets.length }}
                    </div>
                    <div class="text-xs text-blue-600 mt-1">
                        Pilih {{ selectedPackage ? parseOsceId(selectedPackage.osce_id).length : 0 }} lembar sesuai dengan jumlah kasus
                    </div>
                </div>
                
                <!-- Search Input -->
                <div class="mb-4">
                    <p-iconField iconPosition="left">
                        <p-inputIcon>
                            <i class="pi pi-search"></i>
                        </p-inputIcon>
                        <input pInputText type="text" [(ngModel)]="sheetSearchValue" (input)="onSheetSearch()" placeholder="Cari lembar..." class="w-full" />
                    </p-iconField>
                </div>
                
                <div *ngIf="filteredSheetCases.length === 0" class="text-gray-400 italic">Tidak ada data lembar ditemukan.</div>
                <div *ngIf="filteredSheetCases.length > 0" class="flex flex-col gap-3 max-h-60 overflow-y-auto">
                    <div *ngFor="let sheet of filteredSheetCases"
                        class="border rounded-lg p-4 flex items-center justify-between transition-all cursor-pointer"
                        [ngClass]="{
                            'bg-blue-100 border-blue-500': isSheetSelected(sheet),
                            'hover:bg-gray-50': !isSheetSelected(sheet)
                        }"
                        (click)="toggleSheetSelection(sheet)">
                        <div class="flex items-center gap-3">
                            <input 
                                type="checkbox" 
                                [checked]="isSheetSelected(sheet)"
                                (change)="toggleSheetSelection(sheet)"
                                class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                            />
                            <span class="font-semibold">{{ sheet.name || sheet.title || '-' }}</span>
                        </div>
                        <p-button 
                            [label]="isSheetSelected(sheet) ? 'Terpilih' : 'Pilih'" 
                            size="small" 
                            (click)="toggleSheetSelection(sheet)" 
                            [severity]="isSheetSelected(sheet) ? 'success' : 'info'"
                            [icon]="isSheetSelected(sheet) ? 'pi pi-check' : 'pi pi-plus'">
                        </p-button>
                    </div>
                </div>
                <div class="flex gap-2 justify-end mt-6">
                    <p-button label="Clear Semua" icon="pi pi-times" severity="secondary" (click)="clearAllSheetSelection()" [disabled]="selectedSheets.length === 0"></p-button>
                    <p-button 
                        label="Simpan" 
                        icon="pi pi-save" 
                        severity="success" 
                        (click)="saveSheetSelection()" 
                        [disabled]="!isValidSheetSelection()"
                        [tooltip]="getSheetValidationMessage()"
                        tooltipPosition="top">
                    </p-button>
                </div>
            </div>
        </p-dialog>

        <h3 class="mb-4">Manajemen Paket Simulasi</h3>
        <div class="card p-4">
            <div class="flex justify-end mb-4">
                <p-button icon="pi pi-plus" label="Tambah Paket" severity="primary" (click)="showDialog()"></p-button>
            </div>
            <p-table
                #dt
                [value]="packages"
                [rowHover]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                [paginator]="true"
                currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} entri"
                [filterDelay]="0"
                [globalFilterFields]="['name', 'code', 'status']"
                [scrollable]="true"

                class="mt-8 shadow-md rounded-lg overflow-hidden"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-between">
                        <p-button [outlined]="true" icon="pi pi-filter-slash" label="Bersihkan" (click)="clear(dt)" />
                        <p-iconField iconPosition="left">
                            <p-inputIcon>
                                <i class="pi pi-search"></i>
                            </p-inputIcon>
                            <input pInputText type="text" [(ngModel)]="searchValue" (input)="onInput($event, dt)" placeholder="Cari kata kunci" />
                        </p-iconField>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr class="bg-gray-100">
                        <th class="py-3 px-4 text-left" style="min-width: 15rem">

                        </th>
                        <th pSortableColumn="code" class="py-3 px-4 text-left"style="min-width: 10rem">
                            <div class="flex items-center">
                                Kode
                                <p-sortIcon field="code" />
                                <p-columnFilter type="text" field="code" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th pSortableColumn="name" class="py-3 px-4 text-left" style="min-width: 14rem">
                            <div class="flex items-center">
                                Nama
                                <p-sortIcon field="name" />
                                <p-columnFilter type="text" field="name" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th class="py-3 px-4 text-left" style="min-width: 50rem">
                            Kasus
                        </th>
                        <th pSortableColumn="start_time_obj" class="py-3 px-4 text-left" style="min-width: 14rem">
                            <div class="flex items-center">
                                Tanggal Mulai
                                <p-sortIcon field="start_time_obj" />
                                <p-columnFilter type="date" field="start_time_obj" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th pSortableColumn="duration" class="py-3 px-4 text-left" style="min-width: 10rem">
                            <div class="flex items-center">
                                Durasi
                                <p-sortIcon field="duration" />
                                <p-columnFilter type="numeric" field="duration" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th class="py-3 px-4 text-center">Lembar</th>
                        <th pSortableColumn="max_user" class="py-3 px-4 text-left" style="min-width: 14rem">
                            <div class="flex items-center">
                                Maksimal Peserta
                                <p-sortIcon field="max_user" />
                                <p-columnFilter type="numeric" field="max_user" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th class="py-3 px-4 text-center">Aksi</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-package>
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="py-2 px-4">
                            <p-button severity="info" label="Ruang" [raised]="true" icon="pi pi-home" styleClass="mr-2" (click)="openRoom(package)" />
                            <p-button severity="success" label="Hasil" [raised]="true" icon="pi pi-history" (click)="openResult(package)" />
                        </td>
                        <td class="py-2 px-4 font-mono text-blue-700 font-semibold">{{ package.code }}</td>
                        <td class="py-2 px-4 font-semibold">{{ package.name }}</td>
                        <td class="py-2 px-4">
                            <ng-container *ngIf="package.osce_id && parseOsceId(package.osce_id).length; else noCases">
                                <div class="flex flex-wrap gap-1">
                                    <ng-container *ngFor="let osce of parseOsceId(package.osce_id)">
                                        <p-tag class="mr-1 mb-1" severity="info" [value]="osce.TITLE"></p-tag>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #noCases>
                                <span class="text-gray-400 italic">Tidak ada kasus</span>
                            </ng-template>
                        </td>
                        <td class="py-2 px-4">
                            {{ package.start_time ? package.start_time : '-' }}
                        </td>
                        <td class="py-2 px-4">
                            <span class="inline-block bg-blue-50 text-blue-700 rounded px-2 py-1 text-xs font-medium"> {{ package.duration ? package.duration / 60 : 0 }} Menit </span>
                        </td>
                        <td class="py-2 px-4">
                            <ng-container *ngIf="package.sheet_cases && package.sheet_cases.length > 0; else noSheet">
                                <div class="flex flex-wrap gap-1">
                                    <ng-container *ngFor="let sheet of package.sheet_cases">
                                        <p-tag class="mr-1 mb-1" severity="success" [value]="sheet.name"></p-tag>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-template #noSheet>
                                <span class="text-gray-400 italic">Belum ada lembar</span>
                            </ng-template>
                        </td>
                        <td class="py-2 px-4">
                            <p-tag severity="secondary" [value]="package.max_user == 0 ? 'Tak Terbatas' : package.max_user" />
                        </td>
                        <td class="py-2 px-4 text-center">
                            <div class="flex justify-center gap-2">
                                <p-button icon="pi pi-plus" variant="text" severity="primary" [raised]="true" class="mr-1" (click)="addSheet(package)" tooltip="Ubah" tooltipPosition="top" />
                                <p-button icon="pi pi-pencil" variant="text" severity="warn" [raised]="true" class="mr-1" (click)="onEdit(package)" tooltip="Ubah" tooltipPosition="top" />
                                <p-button icon="pi pi-trash" variant="text" severity="danger" [raised]="true" (click)="onDelete($event, package)" tooltip="Hapus" tooltipPosition="top" />
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" class="text-center text-gray-400 py-6">Tidak ada paket ditemukan.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    `
})
export class Packages implements OnInit {
    searchValue: string = '';
    forms: any[] = [];
    loading: boolean = true;
    name: string = '';
    code: string = '';
    selectedOsce: any[] = [];
    description: string = '';
    startDate: any = null;
    duration: number = 0;
    maxParticipant: number = 0;
    user: any = {};
    packages: any[] = [];
    visible: boolean = false;
    editingId: string | null = null;
    statusOptions: string[] = [];
    sheetCases: any[] = [];
    filteredSheetCases: any[] = [];
    sheetSearchValue: string = '';
    showSheetDialog: boolean = false;
    sheetLoading: boolean = false;
    selectedSheet: any = null; // Keep for backward compatibility
    selectedSheets: any[] = []; // New property for multiple selection
    selectedPackage: any = null;

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private router: Router
    ) {}

    ngOnInit() {
        this.initApi();
        this.generateCode();
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                this.user = JSON.parse(userStr) || {};
            } catch {
                this.user = {};
            }
        }
    }

    initApi() {
        this.userService.getOsce().then((response) => {
            this.forms = response.data;
            this.loading = false;
            this.getPackageSimulation();
        });
    }

    clear(table: Table) {
        table.clear();
        this.searchValue = '';
    }

    generateCode() {
        this.code = Math.floor(100000 + Math.random() * 900000).toString();
    }

    onSave() {
        const payload = {
            code: Number(this.code),
            name: this.name,
            created_by: this.user.USERNAME,
            description: this.description,
            osce_id: this.selectedOsce && this.selectedOsce.length > 0 ? this.selectedOsce : [],
            // Only use date part for start_time: 'YYYY-MM-DD'
            start_time: this.startDate ? this.formatDateOnly(this.startDate) : '',
            duration: this.duration ? this.duration * 60 : 0, // convert minutes to seconds
            status: 'waiting',
            max_user: this.maxParticipant
        };

        if (this.editingId) {
            // Update mode
            this.userService
                .updatePackageSimulation({ id: this.editingId, ...payload })
                .then((response: any) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Package updated successfully'
                    });
                    this.clearForm();
                    this.visible = false;
                    this.getPackageSimulation();
                })
                .catch((error: any) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update package'
                    });
                });
        } else {
            // Add mode
            this.userService
                .addPackageSimulation(payload)
                .then((response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Package saved successfully'
                    });
                    this.clearForm();
                    this.visible = false;
                    this.getPackageSimulation();
                })
                .catch((error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to save package'
                    });
                });
        }
    }

    clearForm() {
        this.name = '';
        this.selectedOsce = [];
        this.description = '';
        this.startDate = null;
        this.duration = 0;
        this.maxParticipant = 0;
        this.generateCode();
        this.editingId = null;
    }

    showDialog() {
        this.clearForm();
        this.visible = true;
    }

    addSheet(pkg: any) {
        this.showSheetDialog = true;
        this.sheetLoading = true;
        this.selectedSheet = null;
        this.selectedSheets = [];
        this.selectedPackage = pkg;
        this.sheetSearchValue = '';
        this.userService.getSheetCases(null).then((res: any) => {
            this.sheetCases = res.data || [];
            this.filteredSheetCases = [...this.sheetCases];
            
            // Load existing selected sheets from sheet_cases array
            if (pkg.sheet_cases && pkg.sheet_cases.length > 0) {
                this.selectedSheets = pkg.sheet_cases.slice(); // Create a copy
                this.selectedSheet = this.selectedSheets.length > 0 ? this.selectedSheets[0] : null;
            }
            // Fallback to old method if sheet_cases doesn't exist
            else if (pkg.sheet_case_id) {
                try {
                    let sheetIds = [];
                    if (typeof pkg.sheet_case_id === 'string') {
                        sheetIds = JSON.parse(pkg.sheet_case_id);
                    } else if (Array.isArray(pkg.sheet_case_id)) {
                        sheetIds = pkg.sheet_case_id;
                    }
                    
                    if (Array.isArray(sheetIds)) {
                        this.selectedSheets = this.sheetCases.filter(sheet => 
                            sheetIds.some(id => String(sheet.id) === String(id))
                        );
                    } else {
                        // Single ID
                        const found = this.sheetCases.find((s: any) => String(s.id) === String(sheetIds));
                        if (found) {
                            this.selectedSheets = [found];
                        }
                    }
                    this.selectedSheet = this.selectedSheets.length > 0 ? this.selectedSheets[0] : null;
                } catch (error) {
                    console.error('Error parsing sheet_case_id:', error);
                }
            }
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal mengambil data kasus' });
        }).finally(() => {
            this.sheetLoading = false;
        });
    }

    isSheetSelected(sheet: any): boolean {
        return this.selectedSheets.some(s => s.id === sheet.id);
    }

    toggleSheetSelection(sheet: any) {
        const index = this.selectedSheets.findIndex(s => s.id === sheet.id);
        if (index > -1) {
            // Remove from selection
            this.selectedSheets.splice(index, 1);
        } else {
            // Add to selection
            this.selectedSheets.push(sheet);
        }
        // Update selectedSheet for backward compatibility
        this.selectedSheet = this.selectedSheets.length > 0 ? this.selectedSheets[0] : null;
    }

    clearAllSheetSelection() {
        this.selectedSheets = [];
        this.selectedSheet = null;
    }

    onSheetSearch() {
        if (!this.sheetSearchValue || this.sheetSearchValue.trim() === '') {
            this.filteredSheetCases = [...this.sheetCases];
        } else {
            const searchTerm = this.sheetSearchValue.toLowerCase();
            this.filteredSheetCases = this.sheetCases.filter((sheet: any) => 
                (sheet.name && sheet.name.toLowerCase().includes(searchTerm)) ||
                (sheet.title && sheet.title.toLowerCase().includes(searchTerm))
            );
        }
    }

    isValidSheetSelection(): boolean {
        if (!this.selectedPackage) return false;
        const selectedCasesCount = this.parseOsceId(this.selectedPackage.osce_id).length;
        return selectedCasesCount > 0 && this.selectedSheets.length === selectedCasesCount;
    }

    getSheetValidationMessage(): string {
        if (!this.selectedPackage) return 'Paket tidak valid';
        const selectedCasesCount = this.parseOsceId(this.selectedPackage.osce_id).length;
        if (selectedCasesCount === 0) {
            return 'Paket ini belum memiliki kasus yang dipilih';
        }
        if (this.selectedSheets.length === 0) {
            return 'Pilih lembar terlebih dahulu';
        }
        if (this.selectedSheets.length < selectedCasesCount) {
            return `Pilih ${selectedCasesCount - this.selectedSheets.length} lembar lagi (${this.selectedSheets.length}/${selectedCasesCount})`;
        }
        if (this.selectedSheets.length > selectedCasesCount) {
            return `Terlalu banyak lembar dipilih. Hapus ${this.selectedSheets.length - selectedCasesCount} lembar (${this.selectedSheets.length}/${selectedCasesCount})`;
        }
        return `Simpan ${this.selectedSheets.length} lembar untuk paket ini`;
    }

    async saveSheetSelection() {
        if (this.selectedSheets.length === 0 || !this.selectedPackage) return;
        
        // Validasi jumlah lembar harus sama dengan jumlah kasus
        const selectedCasesCount = this.parseOsceId(this.selectedPackage.osce_id).length;
        if (selectedCasesCount === 0) {
            this.messageService.add({ 
                severity: 'warn', 
                summary: 'Peringatan', 
                detail: 'Paket ini belum memiliki kasus yang dipilih.' 
            });
            return;
        }
        
        if (this.selectedSheets.length !== selectedCasesCount) {
            this.messageService.add({ 
                severity: 'warn', 
                summary: 'Peringatan', 
                detail: `Jumlah lembar yang dipilih (${this.selectedSheets.length}) harus sama dengan jumlah kasus (${selectedCasesCount}).` 
            });
            return;
        }
        
        try {
            // For now, we'll save the first selected sheet (for backward compatibility)
            // In the future, this could be updated to handle multiple sheets
            await this.userService.updateSheetPackageSimulation({
                id: this.selectedPackage.id,
                sheet_case_id: JSON.stringify(this.selectedSheets.map(s => s.id)) // Add this for multiple sheets if API supports it
            });
            this.messageService.add({ 
                severity: 'success', 
                summary: 'Berhasil', 
                detail: `${this.selectedSheets.length} lembar berhasil disimpan.` 
            });
            this.showSheetDialog = false;
            this.selectedSheet = null;
            this.selectedSheets = [];
            this.selectedPackage = null;
            this.getPackageSimulation();
        } catch {
            this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal menyimpan lembar.' });
        }
    }

    onInput(event: Event, dt: Table) {
        const inputElement = event.target as HTMLInputElement | null;
        dt.filterGlobal(inputElement?.value ?? '', 'contains');
    }

    onDialogHide() {
        // Optionally reset form or handle dialog close
    }

    formatDateTime(date: any): string {
        // expects JS Date or string, returns 'YYYY-MM-DD HH:mm:ss'
        const d = new Date(date);
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }

    formatDateOnly(date: any): string {
        // expects JS Date or string, returns 'YYYY-MM-DD'
        const d = new Date(date);
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }

    // --- New API methods for package simulation management ---

    async getPackageSimulation(): Promise<any> {
        await this.userService.getPackageSimulation().then((response: any) => {
            this.packages = response.data;
            // Filter dulu, lalu map
            this.packages = this.packages.map((pkg: any) => {
                pkg.start_time = this.formatDateOnly(pkg.start_time);
                pkg.start_time_obj = pkg.start_time ? new Date(pkg.start_time) : null;
                return pkg;
            });

            this.statusOptions = Array.from(
                new Set(this.packages.map((pkg: any) => pkg.status).filter(Boolean))
            );
        });
    }

    updatePackageSimulation(data: any) {
        const payload = {
            code: Number(this.code),
            name: this.name,
            created_by: this.user.USERNAME,
            description: this.description,
            osce_id: this.selectedOsce && this.selectedOsce.length > 0 ? this.selectedOsce : [],
            start_time: this.startDate ? this.formatDateTime(this.startDate) : '',
            duration: this.duration ? this.duration * 60 : 0, // convert minutes to seconds
            status: 'waiting',
            max_user: this.maxParticipant
        };
        return this.userService.updatePackageSimulation(data).then((response: any) => {
            // handle response if needed
        });
    }

    deletePackageSimulation(id: any) {
        return this.userService.deletePackageSimulation(id).then((response: any) => {

        });
    }

    onEdit(pkg: any) {
        // Fill form with selected package data for editing and open dialog
        this.code = pkg.code?.toString() ?? '';
        this.name = pkg.name ?? '';
        this.description = pkg.description ?? '';
        this.selectedOsce = [];
        try {
            this.selectedOsce = pkg.osce_id ? JSON.parse(pkg.osce_id) : [];
        } catch {
            this.selectedOsce = [];
        }
        // Convert start_time string to Date object for datepicker
        this.startDate = pkg.start_time ? new Date((pkg.start_time as string).replace(' ', 'T')) : null;
        this.duration = pkg.duration ? Number(pkg.duration) / 60 : 0;
        this.maxParticipant = pkg.max_user ? Number(pkg.max_user) : 0;
        this.editingId = pkg.id ?? null; // set editing id
        this.visible = true; // open dialog
    }

    onDelete(event: Event, pkg: any) {
        // Add safety check
        if (!pkg || !pkg.id) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Data paket tidak valid'
            });
            return;
        }

        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Apakah Anda yakin ingin menghapus data ini?',
            header: 'Zona Bahaya',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Batal',
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Hapus',
                severity: 'danger',
            },

            accept: () => {
                const payload = {
                    id: pkg.id
                }
                console.log(payload);
                
                this.deletePackageSimulation(payload)
                    .then(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Dihapus',
                            detail: 'Paket berhasil dihapus'
                        });
                        this.getPackageSimulation();
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Gagal',
                            detail: 'Gagal menghapus paket'
                        });
                    });
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Ditolak', detail: 'Anda membatalkan aksi' });
            },
        });
    }

    parseOsceId(osceId: any): any[] {
        try {
            return typeof osceId === 'string' ? JSON.parse(osceId) : Array.isArray(osceId) ? osceId : [];
        } catch {
            return [];
        }
    }

    getStatusSeverity(status: string) {
        switch (status) {
            case 'waiting': return 'info';
            case 'running': return 'success';
            case 'finished': return 'secondary';
            default: return 'contrast';
        }
    }

    openRoom(pkg: any) {
        this.router.navigate([`/app/osce/simulation/room`, pkg.code]);
    }

    openResult(pkg: any) {
        this.router.navigate([`/app/osce/simulation/history`, pkg.code]);
    }
}
